import type { Dayjs } from '@utils/dayjs';
import { useExportTotalsData } from '../../hooks/api/totals';
import { ReactComponent as FileExport } from '../../assets/file-export.svg';
import LoadingButton from '@mui/lab/LoadingButton';
import { FC } from 'react';
import CustomBackdrop from '../UI/CustomBackdrop';

interface TEFExportTotalsButtonProps {
    date: Date | Dayjs | string;
    totalsType: 'bidding' | 'corrected';
}

const TEFExportTotalsButton: FC<TEFExportTotalsButtonProps> = ({ date, totalsType }) => {
    const { mutateAsync: exportTotalsData, isLoading } = useExportTotalsData();

    return (
        <>
            {isLoading && <CustomBackdrop open={true} />}
            <LoadingButton
                variant="contained"
                onClick={() => exportTotalsData({ date, totalsType })}
                loading={isLoading}
                disabled={isLoading}
            >
                <FileExport />
            </LoadingButton>
        </>
    );
};

export default TEFExportTotalsButton;
